<template>
    <div class="general">
        <filtro-cadu
            v-model="valueData"
            @limparFiltro="limparFiltro()"
            @filtrar="filtraAnexos()"
        >
            <div slot="body" class="filtro-consulta">
                <v-row class="px-5">
                    <v-col cols="12">
                        <input-cadu
                            title="Nome do Dirigente"
                            v-model="nomeDirigente"
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                            :max="60"
                        />
                    </v-col>
                    <v-col cols="12">
                        <input-cadu
                            title="CPF"
                            v-model="cpf"
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                            mask="###.###.###-##"
                        />
                    </v-col>
                    <v-col cols="12">
                        <input-cadu
                            title="CRM"
                            v-model="crm"
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                            mask="########"
                        />
                    </v-col>
                    <v-col cols="12" v-if="role === 'admin_brasil'">
                        <autocomplete-cadu
                            :items="listarUnimeds.map((el) => el.textoExibicao)"
                            title="Unimed"
                            v-model="unimed.nome"
                            @index="indexUnimed"
                        />
                    </v-col>
                </v-row>
            </div>
        </filtro-cadu>
        <error-modal
            v-model="error"
            :errObj="errObj"
        />
    </div>
</template>

<script>
import ListarUnimeds from '@/services/Unimed/ListarUnimed'
import jwtDecode from 'jwt-decode'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      nomeDirigente: '',
      cpf: '',
      crm: '',
      unimed: {
        nome: '',
        id: ''
      },
      listarUnimeds: [],
      valueData: this.value,
      error: false,
      errObj: {},
      tokenBearer: localStorage.getItem('tokenBearer'),
      role: ''
    }
  },
  beforeMount () {
    this.role = jwtDecode(this.tokenBearer).role
    this.getAllUnimeds()
  },
  methods: {
    indexUnimed (index) {
      this.unimed.id = index !== null && index > -1 ? this.listarUnimeds[index].id : ''
    },
    async getAllUnimeds () {
      const listar = new ListarUnimeds(this.tokenBearer, this.$appConfig.config.API)

      try {
        const response = await listar.getAll()
        this.listarUnimeds = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    limparFiltro () {
      this.nomeDirigente = ''
      this.cpf = ''
      this.crm = ''
      this.unimed = {
        nome: '',
        id: ''
      }
    },
    filtraAnexos () {
      this.$emit('filtrar', {
        nome: this.nomeDirigente,
        cpf: this.cpf,
        crm: this.crm,
        unimedId: this.unimed.id
      })
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      this.$emit('input', this.valueData)
    }
  }
}
</script>
